/* eslint-disable */
import React, { useState } from 'react';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Button from 'src/onboarding/components/ui/button/Button';
import { MultiImageSelect } from 'src/onboarding/components/ui/multi-image-select/MultiImageSelect';
import { ImageOption } from 'src/onboarding/components/ui/multi-image-select/ImageOption';
import { images } from 'src/onboarding/constants/images';

function Page() {
  const chooseDinner = useStore((state) => state.chooseDinner);
  const setChooseDinner = useStore((state) => state.setChooseDinner);
  const [next, setNext] = useState(chooseDinner.length > 0);
  const { onNext, onPrev, currentIndex } = useNav();

  const handleChange = (value) => {
    setChooseDinner(value);
    setNext(value.length > 0);
  };

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.chooseDinner.title')}</Title>
        <Text className='description' size='m' medium style={{ padding: '0 35px' }}>
          {t('onboarding.chooseDinner.subTitle')}
        </Text>
      </div>

      <div className={'cards'} style={{ marginBottom: 70 }}>
        <MultiImageSelect
        onChange={handleChange}
        defaultValue={chooseDinner}
      >
        <ImageOption
          value="Turkey steak with vegetables"
          image={images.dinner64}
          label={t('onboarding.chooseDinner.options.steak')}
        />
        
        <ImageOption 
          value="Asian-style squid rice"
          image={images.dinner73}
          label={t('onboarding.chooseDinner.options.rice')}
        />
        
        <ImageOption 
          value="Pasta with chicken and vegetables"
          image={images.dinner76}
          label={t('onboarding.chooseDinner.options.pasta')}
        />
        
        <ImageOption 
          value="Cod cutlets with a side of fresh vegetables"
          image={images.dinner80}
          label={t('onboarding.chooseDinner.options.cutlets')}
        />
        <ImageOption 
          value="Sea bass with potatoes"
          image={images.dinner83}
          label={t('onboarding.chooseDinner.options.seabass')}
        />
        <ImageOption 
          value="Chili con carne"
          image={images.dinner81}
          label={t('onboarding.chooseDinner.options.chili')}
        />
      </MultiImageSelect>
      <div className={'overlay'}></div>
      </div>

      <div className={'next-wrapper'}>
        <Button
          className={next ? '' : 'disabled'}
          title={t('onboarding.eatingHabits.continue')}
          onClick={() => {
            if (!next) return;
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'choose-dinner',
              answer: chooseDinner.join(', '),
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
